<template>
  <b-row>
    <b-col cols="12">
      <router-link :to="{ name: 'EXABPackagesList' }" class="mb-1 btn btn-sm btn-default float-right">
        {{$t('buttons.backToList')}}
      </router-link>
    </b-col>
    <b-col cols="12" class="mt-2">
      <b-card>
        <loader v-if="isLoading"></loader>
        <div v-else class="card-body">
          <Form
            :handle-submit="handleSubmit"
            :handle-update-field="updateField"
            :values="retrieved"
            :initial-values="item"
            :violations="violations">
          </Form>
        </div>
      </b-card>
    </b-col>
  </b-row>
</template>

<script>
import Form from './Form'
import { mapActions, mapGetters, mapMutations } from 'vuex'
import Loader from '@/components/Dashboard/Layout/Loader'
import { checkPagePermission } from '@/utils/checkRoles'

export default {
  name: 'Update',
  components: {
    Form,
    Loader
  },

  data () {
    return {
      item: {}
    }
  },

  watch: {
    'updated' (val) {
      if (val) {
        this.$router.push({ name: 'EXABPackagesList' })
      }
    }
  },

  beforeCreate () {
    checkPagePermission('exabagreements', 'EXABPackagesUpdate')
  },

  computed: {
    ...mapGetters({
      updated: 'packages/update/updated',
      violations: 'packages/update/violations',
      retrieved: 'packages/update/retrieved',
      isLoading: 'packages/update/isLoading'
    })
  },

  beforeDestroy () {
    this.reset()
  },

  created () {
    this.retrieve(this.$route.params.id)
  },

  methods: {
    handleSubmit () {
      this.update(this.retrieved)
    },
    updateField (field, value) {
      Object.assign(this.retrieved, { [field]: value })
    },
    ...mapActions({
      update: 'packages/update/update',
      retrieve: 'packages/update/retrieve'
    }),
    ...mapMutations({
      reset: 'packages/update/reset'
    })
  }
}
</script>
